<template>
  <div
    :class="[
      `design-system-input flex w-full cursor-text items-center rounded-lg border transition`,
      `outline-2 -outline-offset-1 has-[:focus-visible]:outline`,
      isDisabled && `opacity-50`,
      fieldContext?.validationStatus.value === 'error'
        ? `border-red-300 outline-red-500 dark:border-red-800`
        : `outline-blue-500`,
    ]"
    @keydown="handleKeydown"
  >
    <TimeSegments
      ref="segments"
      v-model="modelValue"
      :disabled="isDisabled"
      class="p-1.5"
    />

    <div class="mx-1 shrink-0 p-1.5 text-muted-foreground">
      <ClockIcon class="size-4" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ClockIcon from "@/icons/heroicons/clock-micro.svg";

import { injectFieldContext } from "./context";
import TimeSegments from "./internal/TimeSegments.vue";

const modelValue = defineModel<string>({ default: "" });

const props = defineProps<{
  disabled?: boolean;
}>();

const fieldContext = injectFieldContext(null);

const isDisabled = computed(() => {
  return fieldContext?.disabled.value || props.disabled;
});

const handleKeydown = (): void => {
  // Reserved for future keyboard shortcuts
};
</script>
